import React from 'react'
import InfoSvg from 'images/modules/Manage/i-info.svg?raw'

export { default as InfoUrl } from 'images/modules/Manage/i-info.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: InfoSvg}} />
)
